import { InMemoryStore } from './InMemoryStore';

// eslint-disable-next-line import/no-anonymous-default-export
const inmemorystorage: InMemoryStore = new InMemoryStore();

export default inmemorystorage;
